// ApartmentList.jsx
import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import "./ApartmentList.css";

const ApartmentList = ({ apartments }) => {
    if (!apartments) {
        // показываем одну карточку-загрузку
        return (
            <div className="apartment-list">
                <div className="loader-wrapper">
                    <div className="loader" />
                </div>
            </div>
        );
    }
    return (
        <div className="apartment-list">
            {apartments.map((apartment, index) => {
                const priceData = Object.entries(apartment.prices)
                    .map(([date, priceObj]) => ({
                        date,
                        price: priceObj.price,
                        available: priceObj.available,
                    }))
                    .sort((a, b) => new Date(a.date) - new Date(b.date));


                return (
                    <div key={index} className="apartment-card">
                        <div className="apartment-link">
                            <a href={apartment.url} target="_blank" rel="noopener noreferrer">
                                {apartment.url}
                            </a>
                        </div>

                        <div className="apartment-info">
                            <p>Этаж: {apartment.data.floor} / {apartment.data.floors}</p>
                            <p>Комнат: {apartment.data.rooms}</p>
                            <p>Площадь: {apartment.data.area} м²</p>
                        </div>

                        <div className="apartment-chart">
                            <ResponsiveContainer width="100%" height="100%">
                                <LineChart data={priceData}>
                                    <XAxis dataKey="date" />
                                    <YAxis />
                                    <Tooltip />
                                    <Line
                                        type="monotone"
                                        dataKey="price"
                                        stroke="#8884d8"
                                        strokeWidth={2}
                                        dot={false}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ApartmentList;
